module.exports = __webpack_public_path__ + "img/img19.1b52ea19.png";